import { render } from "./allstocktransfer.vue?vue&type=template&id=1fe4e6ce&scoped=true"
import script from "./allstocktransfer.vue?vue&type=script&lang=js"
export * from "./allstocktransfer.vue?vue&type=script&lang=js"

import "./allstocktransfer.vue?vue&type=style&index=0&id=1fe4e6ce&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe4e6ce"]])

export default __exports__